// extracted by mini-css-extract-plugin
module.exports = {"leaveAgentQueueButton":"LeaveAgentQueueButton_leaveAgentQueueButton__Lfpyt","hidden":"LeaveAgentQueueButton_hidden__EIgUu"};